<template lang="html"><div></div> </template>

<script>
import { mapState } from "vuex";
export default {
  computed: mapState(["loading"]),
  methods: {
    toggleLoading() {
      if (this.loading == 1) {
        this.$vs.loading();
      } else if (this.loading == 0) {
        this.$vs.loading.close();
      }
    }
  },
  mounted() {
    this.$store.watch(state => state.loading, this.toggleLoading);
  }
};
</script>
